import React from 'react';
import { CurrencyToString } from '@wix/premium-react-text';
import { Badge, Box, Text } from '@wix/design-system';
import classNames from 'classnames';
import s from './CheckoutRowLabel.scss';
import { CycleMultiplier, PaymentCycle } from '../../../utils';
import { TFunction } from 'i18next';

const SPACE_NOTE = ' ';
interface CheckoutRowLabelProps {
  currentCycle: PaymentCycle;
  cycleMonthlyPrice: number;
  showDiscountSavings: boolean;
  showStrikePrice: boolean;
  discountSavingsText: string;
  monthlyFullPriceText: string;
  t: TFunction;
  currencyToString: CurrencyToString;
}

const CheckoutRowLabelComp: React.FC<CheckoutRowLabelProps> = ({
  currentCycle,
  cycleMonthlyPrice,
  showStrikePrice,
  showDiscountSavings,
  discountSavingsText,
  monthlyFullPriceText,
  t,
  currencyToString,
}) => {
  const cycleString =
    currentCycle === PaymentCycle.MONTHLY
      ? `/ ${t('checkout.summary.every_month')}`
      : t('checkout.summary.months', {
          multiplier: CycleMultiplier[currentCycle],
        });

  return (
    <>
      <Text>
        {showStrikePrice && (
          <span
            className={classNames(s.strikethroughPrice)}
            data-hook="striked-price"
          >
            {`${monthlyFullPriceText}${SPACE_NOTE}`}
          </span>
        )}
        {`${currencyToString(cycleMonthlyPrice)} ${cycleString}`}
      </Text>
      {showDiscountSavings && (
        <Box>
          <Badge
            className={classNames(s.savingsBadge)}
            dataHook="checkout-savings-badge"
            size="medium"
            skin="success"
            type="outlined"
          >
            <div className={classNames(s.savingsBadgeText)}>
              {t('Advanced.Plans_General_checkout.savings', {
                savingsPrice: discountSavingsText,
              })}
            </div>
          </Badge>
        </Box>
      )}
    </>
  );
};

export const CheckoutRowLabel = React.memo(CheckoutRowLabelComp);
